import { render } from "./ClientAvailableScopesComponent.vue?vue&type=template&id=69dc450d"
import script from "./ClientAvailableScopesComponent.vue?vue&type=script&lang=js"
export * from "./ClientAvailableScopesComponent.vue?vue&type=script&lang=js"

import "./ClientAvailableScopesComponent.vue?vue&type=style&index=0&id=69dc450d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__